import { CareTeamDocument } from '@/api/catchAll/careTeamDocuments/types'

export const CONNECT_ARTICLES_PROPS = {
  externalThymeboxPatientId: {
    type: String,
    required: false,
  },
} as const

type ArticleWithDoc = {
  document: CareTeamDocument
  strapiArticleTitle: string
}

export type ArticlesWithDocumentsByCategory = Record<
  string,
  Record<string, ArticleWithDoc>
>
